<template>
  <div class="w-100 h-100 d-flex justify-content-center align-items-center">
    <div class="form-login row col-12 col-md-4 bg-dark p-3 mt-4">
      <form class="mb-1" @submit.prevent="login">
        <div class="col-12 d-flex justify-content-center my-4">
          <img alt="Akdemica logo" class="w-50" src="../../assets/img/logo-completa.png">
        </div>

        <div class="col-12 mt-2">
          <label><small>Usuário</small></label>
          <input
            v-model="form.email"
            class="form-control"
            type="email"
            :class="{ 'is-invalid': form.errors.has('email') }"
          />
          <has-error :form="form" field="email"></has-error>
        </div>

        <div class="col-12 mt-2">
          <label><small>Senha</small></label>
          <input
            v-model="password"
            class="form-control"
            type="password"
            :class="{ 'is-invalid': form.errors.has('password') }"
          />
          <has-error :form="form" field="password"></has-error>
        </div>

        <div class="col-12 mt-2">
          <button class="btn btn-success form-control"><b>Entrar</b></button>
        </div>
      </form>

      <p class="text-center mt-3 mb-1 col-12">
        <a href="/reset">Esqueci a minha senha.</a>
      </p>

    </div>
  </div>
</template>

<script>
import Axios from 'axios'
import hash from 'hash.js'
import { mapActions } from 'vuex'
import { Form } from 'vform'

export default {
  data () {
    return {
      password: undefined,
      form: new Form({
        email: undefined,
        password: undefined,
      }),
    }
  },
  methods: {
    ...mapActions({
      setLoginTrue: 'login'
    }),

    registerLoginData: function ( data ) {
      localStorage.setItem('ak-adm-token', data.token)
      this.$store.commit('LOGIN_USER')
      this.$store.commit('SET_CURRENT_USER', data.info)
      Axios.defaults.headers.common['Authorization'] = `Bearer ${ localStorage.getItem('ak-adm-token') }`

      if ( this.$route.query.redirect ) {
        this.$router.push( this.$route.query.redirect )
      } else {
        this.$router.push('/painel')
      }
    },

    login: function () {
      this.form.password = hash.sha256().update( this.password ).digest('hex')

      this.form.post('/auth/admin/login')
        .then( res => {
          this.registerLoginData( res.data )
        })
        .catch ( err => {
          console.error('erro', err)
          this.form.errors.set('password', err.response.data.error)
        })
    }
  }
}
</script>
